var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-row",
    { staticStyle: { "margin-top": "20px" }, attrs: { type: "flex" } },
    [
      _c(
        "a-col",
        { attrs: { flex: "300px" } },
        _vm._l(_vm.cardList, function (item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "card-item",
              class: { "card-active": _vm.currCardId === item.id },
              on: {
                click: function ($event) {
                  return _vm.toggleCard(item, index)
                },
              },
            },
            [
              _c("div", { staticClass: "card-title" }, [
                _vm._v(_vm._s(item.title)),
              ]),
              _c("div", [
                _vm._v(
                  "\n        活动日期：" +
                    _vm._s(
                      _vm.classDetail.beginDate || _vm.viewRecord.beginDate
                    ) +
                    " 至\n        " +
                    _vm._s(_vm.classDetail.endDate || _vm.viewRecord.endDate) +
                    "\n      "
                ),
              ]),
            ]
          )
        }),
        0
      ),
      _c(
        "a-col",
        { attrs: { flex: "2px" } },
        [
          _c("a-divider", {
            staticStyle: { height: "600px" },
            attrs: { type: "vertical" },
          }),
        ],
        1
      ),
      _c(
        "a-col",
        { attrs: { flex: "auto" } },
        [
          _c(
            "a-tabs",
            {
              attrs: { activeKey: _vm.currTabKey },
              on: { change: _vm.changeTab },
            },
            [
              _vm._l(_vm.tabList, function (item, index) {
                return _c(
                  "a-tab-pane",
                  {
                    key: item.key,
                    attrs: {
                      tab: `${item.tab}(${_vm.tabList[index]?.num || 0})`,
                    },
                  },
                  [
                    _c("TableList", {
                      staticStyle: { width: "100%", "margin-top": "10px" },
                      attrs: {
                        columns: _vm.columns,
                        tableData: _vm.dataSource,
                        loading: _vm.loading,
                        scroll: {},
                        pagination: _vm.ipagination,
                      },
                      on: { change: _vm.handleTableChange },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "action",
                            fn: function ({ record }) {
                              return [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      color: "#1783e8",
                                      cursor: "pointer",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.viewReport(record)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              查看报告\n            "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                  ],
                  1
                )
              }),
              _c(
                "a-button",
                {
                  attrs: { slot: "tabBarExtraContent", type: "primary" },
                  on: { click: _vm.exportXls },
                  slot: "tabBarExtraContent",
                },
                [_vm._v("导出")]
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c("DetailedReport", { ref: "detailedReportRef" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }